var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.7,
    height: 19.7,
    viewBox: "0 0 19.7 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pharmacy",
    transform: "translate(-290.034 -413.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15862",
    "data-name": "Path 15862",
    d: "M157.65,290.686a9.5,9.5,0,1,1,9.42,9.5A9.506,9.506,0,0,1,157.65,290.686Zm.711,0a8.789,8.789,0,1,0,8.812-8.789A8.795,8.795,0,0,0,158.361,290.69Z",
    transform: "translate(132.734 132.777)",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15864",
    "data-name": "Path 15864",
    d: "M225.989,349.628v-1.983c0-.734.274-1,1.015-1s1.49,0,2.234,0a.8.8,0,0,1,.893.9c0,.684,0,1.368,0,2.09h.286c.609,0,1.219,0,1.828,0a.8.8,0,0,1,.873.866q.009,1.206,0,2.412a.8.8,0,0,1-.879.86c-.6,0-1.2,0-1.8,0h-.305v.294c0,.609,0,1.219,0,1.828a.794.794,0,0,1-.848.864q-1.219.009-2.437,0a.8.8,0,0,1-.854-.859c0-.609,0-1.219,0-1.828v-.3h-1.646c-.178,0-.356.005-.533,0a.775.775,0,0,1-.8-.778q-.023-1.295,0-2.59a.774.774,0,0,1,.836-.77C224.545,349.624,225.247,349.628,225.989,349.628Zm4.98,3.429c.4,0,.8-.008,1.193,0,.185.005.254-.05.252-.243q-.013-1.116,0-2.234c0-.187-.056-.25-.246-.248-.736.009-1.472,0-2.208,0-.455,0-.538-.081-.538-.527,0-.728-.006-1.455,0-2.183,0-.2-.041-.286-.263-.282-.736.013-1.472.012-2.208,0-.206,0-.258.07-.255.265.009.753.005,1.506,0,2.259,0,.362-.106.467-.47.468-.753,0-1.506.006-2.259,0-.2,0-.267.05-.265.256q.016,1.1,0,2.208c0,.2.057.264.26.261.736-.011,1.472,0,2.208,0,.438,0,.525.086.525.514,0,.736.008,1.472,0,2.208,0,.217.072.271.277.269.728-.01,1.455-.012,2.183,0,.217,0,.271-.072.269-.277-.01-.761-.006-1.523,0-2.284,0-.315.114-.425.43-.429C230.224,353.054,230.6,353.058,230.969,353.057Z",
    transform: "translate(71.824 71.768)",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.51e6b4e16bcce0a03b3fd3398c339c2c.svg";
export { ForwardRef as ReactComponent };